import { select } from '@js/util/select.js'

let loadedCalendly = false
let initializedCalendly = false

// If there is a Consent Manager "calendly" service, wait for that to be approved
const cmService = 'calendly'

if (cmService && window.obConsentManagerConfig) {
  ;(async () => {
    await window.obConsentManagerReady

    if (window.obConsentManager.hasService(cmService)) {
      await window.obConsentManager.awaitConsent(cmService)
    }
    initializeCalendlyIntegration()
  })()
} else {
  initializeCalendlyIntegration()
}

function initializeCalendlyIntegration() {
  select('a[href^="https://calendly.com/"]', link => {
    if (!loadedCalendly) {
      loadedCalendly = true

      const script = document.createElement('script')
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      document.body.appendChild(script)
      const initializedCalendlyJs = new Promise((resolve, reject) => {
        script.addEventListener('load', resolve)
        script.addEventListener('error', reject)
      })

      const stylesheet = document.createElement('link')
      stylesheet.rel = 'stylesheet'
      stylesheet.href = 'https://assets.calendly.com/assets/external/widget.css'
      document.head.appendChild(stylesheet)
      const initializedCalendlyCss = new Promise((resolve, reject) => {
        stylesheet.addEventListener('load', resolve)
        stylesheet.addEventListener('error', reject)
      })

      Promise.all([initializedCalendlyJs, initializedCalendlyCss]).then(() => {
        initializedCalendly = true
      })
    }

    // Add embed_* parameters to the Calendly URL
    const url = link.href
    const urlObject = new URL(url)
    urlObject.searchParams.set('embed_domain', new URL(window.location.href).hostname)
    urlObject.searchParams.set('embed_type', 'PopupText')
    link.href = urlObject.toString()

    link.addEventListener('click', event => {
      console.log('INTEGRATION', initializedCalendly)
      if (!initializedCalendly) return

      event.preventDefault()
      window.Calendly.initPopupWidget({ url: link.href })
    })
  })
}
